import script from "./StudiesSwiper.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudiesSwiper.vue?vue&type=script&lang=ts&setup=true"

import "./StudiesSwiper.vue?vue&type=style&index=0&id=e2d8662c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2d8662c"]])

export default __exports__